export const genderList = [
    { id: 1, value: 'MALE', title: 'Male' },
    { id: 2, value: 'FEMALE', title: 'Female' },
    { id: 3, value: 'OTHER', title: 'Other' },
];
